<template>
  <div>
    <customModal
      v-if="modalData"
      v-show="modalData"
      ref="confirmModal"
      :onModalClose="() => modalData = null"
      :onModalAccept="() => acceptRecord(null, true, true)"
      :modalData="modalData"
    />

    <table class="table table-sm table-hover border mb-1 mt-0">
      <tbody>
      <tr v-for="e in expenses" :key="e.id" v-if="!e.is_confirmed">
        <td class="fix_width">{{ printDate(e.pass_date, 'DD.MM.YYYY') }}</td>
        <td class="fix_big_width">
          <p>{{ expensesTypes[e.type_id] }}</p>
          <p class="text-muted">{{ $AllDivisions[e.division_id]?.title }}</p>
        </td>
        <td>{{ e.comment }}</td>
        <td class="fix_width">{{ $AllCurrencies[e.currency_id]?.currency }} <strong>{{ e.sum }}</strong></td>
        <td class="fix_width" align="right">
          <div class="btn-group">
            <LoadingButton
              title='<i class="icon-fa icon-fa-remove"/>'
              type="button"
              :loading="btnLoading[e.id]"
              :color="$constants.DANGER_COLOR"
              :onClick="() => acceptRecord(e.id, true)"
              className="btn btn-outline-danger"
            />
            <LoadingButton
              title='<i class="icon-fa icon-fa-check"/>'
              type="button"
              :loading="btnLoading[e.id]"
              :color="$constants.SUCCESS_COLOR"
              :onClick="() => acceptRecord(e.id)"
              className="btn btn-success"
            />
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import customModal from "@/components/modals/customModal.vue";

export default {
  components: {customModal, LoadingButton},
  props: ['expenses', 'expensesTypes'],
  data() {
    return {
      modalData: null,
      btnLoading: {}
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
  },
  created() {
    this.btnLoading = this.expenses.reduce((acc, e) => {
      acc[e.id] = false;
      return acc;
    }, {})
  },
  methods: {
    async acceptRecord(id, remove = false, confirm = false) {
      if (remove && !confirm) {
        this.modalData = {
          id,
          header: 'Вы уверены?',
          body: 'Действительно хотите удалить запись',
          acceptBtnText: 'Да',
          cancelBtnText: 'Нет'
        }
        return;
      }
      if (remove && confirm) {
        id = this.modalData.id;
        this.modalData = null;
      }
      this.btnLoading[id] = true;
      const {data} = await api.post("/reports/updateExpenses", {
        expenses: [{id: id}],
        action: remove ? 'reject' : 'confirm'
      });
      if (data.success) {
        const index = this.expenses.findIndex((e) => e.id === id);
        if (index !== -1) {
          this.expenses[index].is_confirmed = 1;
        }
        toastr['success'](data.message || 'сохранено', 'Успешно');
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно');
      }
      this.btnLoading[id] = false;
    }
  }
}

</script>

<style scoped>
table td {
  padding: 5px;
}

.fix_big_width {
  width: 200px;
}

.fix_big_width p {
  text-overflow: ellipsis;
}

.fix_width {
  width: 100px;
}
</style>
